var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIconListPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.42481 0C7.99628 0 10.0908 2.09454 10.0908 4.66601C10.0908 5.71197 9.49357 6.96104 9.10421 7.68447L5.838 13.7503C5.78495 13.8513 5.69686 13.9293 5.59032 13.9697C5.48367 14.0101 5.36607 14.0101 5.25942 13.9697C5.15288 13.9293 5.06479 13.8513 5.01173 13.7503L1.74553 7.68447C1.35614 6.96116 0.758915 5.71208 0.758915 4.66601C0.758915 2.09454 2.85345 0 5.42492 0H5.42481ZM5.42481 0.933257C3.35771 0.933257 1.69201 2.59894 1.69201 4.66606C1.69201 5.29184 2.22374 6.5959 2.57177 7.24209L5.4247 12.54L8.27791 7.24209C8.62583 6.59579 9.15756 5.29184 9.15756 4.66606C9.15756 2.59897 7.49188 0.933257 5.42476 0.933257H5.42481ZM5.42481 2.17755C6.79365 2.17755 7.9134 3.29728 7.9134 4.66615C7.9134 6.03501 6.79379 7.15474 5.42481 7.15474C4.05598 7.15474 2.93622 6.03501 2.93622 4.66615C2.93622 3.29728 4.05584 2.17755 5.42481 2.17755ZM5.42481 3.11081C4.56035 3.11081 3.86948 3.80169 3.86948 4.66615C3.86948 5.53061 4.56024 6.22148 5.42481 6.22148C6.28927 6.22148 6.98015 5.53061 6.98015 4.66615C6.98015 3.80169 6.28927 3.11081 5.42481 3.11081Z",
    fill: "#707372"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIconListPage);
export default __webpack_public_path__ + "static/media/location-icon-list-page.a65b1c0d2e97d560016961b84c6628aa.svg";
export { ForwardRef as ReactComponent };